import { API_BASE_URL } from './config';

interface LoginResponse {
  success: boolean;
  data?: {
    id: string;
    username: string;
    role: 'admin' | 'sales' | 'fulfillment';
  };
  error?: string;
}

export async function login(username: string, password: string): Promise<LoginResponse['data']> {
  try {
    const response = await fetch(`${API_BASE_URL}/login.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password })
    });

    const data: LoginResponse = await response.json();

    if (!response.ok || !data.success || !data.data) {
      throw new Error(data.error || 'Invalid username or password');
    }

    // Store auth data in localStorage
    localStorage.setItem('auth', JSON.stringify(data.data));
    
    return data.data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Login failed. Please try again.');
  }
}

export function logout(): void {
  localStorage.removeItem('auth');
}

export function getAuthUser(): LoginResponse['data'] | null {
  try {
    const auth = localStorage.getItem('auth');
    return auth ? JSON.parse(auth) : null;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  return getAuthUser() !== null;
}

export function hasRole(role: 'admin' | 'sales' | 'fulfillment'): boolean {
  const user = getAuthUser();
  return user?.role === role || user?.role === 'admin';
}

export function isAdmin(): boolean {
  const user = getAuthUser();
  return user?.role === 'admin';
}